import { render, staticRenderFns } from "./complementos.vue?vue&type=template&id=411f1ff0"
import script from "./complementos.vue?vue&type=script&lang=js"
export * from "./complementos.vue?vue&type=script&lang=js"
import style0 from "./complementos.vue?vue&type=style&index=0&id=411f1ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports